import {IObservable, mkObservable} from "./Observable";
export const startWith = <T>(init: T, source: IObservable<T>): IObservable<T> => mkObservable(observer => {
  observer.next(init);
  return source.subscribe(observer);
});
